import { Locale } from '@shopee-user/global';
import { config } from '@shopee-user/platform';
import createPhoneUtils, {
  PhoneNumberPrettyFormat,
  minimizePhoneNumber,
} from '@shopee/phone-utils';

// whitelist SG and SZ phone number for QA to test
const PHONE_PREFIX_WHITE_LIST_FOR_NON_PRODUCTION = ['00', '+86', '+65'];

const {
  parse,
  mobilePhoneValidator,
  localMobilePhoneValidator,
  prettifyPhoneNumber: prettifyPhoneNumberCore,
  isValidMobilePhone,
  isValidLocalMobilePhone,
  formatPhoneNumberForServer,
  loadPhoneLibrary,
} = createPhoneUtils(
  // We use SG as default country for phone validation
  config.LOCALE === Locale.GLOBAL ? Locale.SG : config.LOCALE,
  config.ENV as 'live' | 'liveish' | 'stable' | 'test' | 'staging' | 'uat',
  {
    devPrefixWhitelist: PHONE_PREFIX_WHITE_LIST_FOR_NON_PRODUCTION,
  }
);

/**
 * Format the phone string to E164 format by passing the V2 format
 * Note that E164 format is the standard display format for phone https://en.wikipedia.org/wiki/E.164
 * @param phone - The phone string to prettify
 * @returns The phone string in E164 format
 */
const prettifyPhoneNumber = async (phone = '') => {
  return prettifyPhoneNumberCore(phone, PhoneNumberPrettyFormat.V2);
};

export {
  parse,
  mobilePhoneValidator,
  localMobilePhoneValidator,
  minimizePhoneNumber,
  prettifyPhoneNumber,
  isValidMobilePhone,
  isValidLocalMobilePhone,
  formatPhoneNumberForServer,
  loadPhoneLibrary,
};
